import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import DetailWriteDTO from '../../../../../../types/detail/DetailWriteDTO';
import { DetailService } from '../../../../services/detail.service';

@Component({
    selector: 'app-create-detail-dialog',
    templateUrl: './create-detail-dialog.component.html',
    styleUrls: [ './create-detail-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        CheckboxModule,
        IconField,
        InputIcon,
        IftaLabelModule
    ]
})
export class CreateDetailDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() detailCreated: EventEmitter<DetailWriteDTO> = new EventEmitter<DetailWriteDTO>();

    public detail: DetailWriteDTO = new DetailWriteDTO({});
    public loading = false;

    constructor(
        private detailService: DetailService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        // Any initialization logic can go here
    }

    get saveDisabled(): boolean {
        return !this.detail.name; // Disable if no name is provided
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveDetail(): void {
        this.loading = true;
        this.detailService
            .createDetail(this.detail)
            .then(() => {
                this.detailCreated.emit(this.detail);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000
                });
            })
            .finally(() => {
                // Reset the form
                this.detail = new DetailWriteDTO({});
                this.loading = false;
            });
    }
}
